import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PaymentResult.css';

export const PaymentCancel: React.FC = () => {
  return (
    <div className="payment-result">
      <div className="payment-result__card cancelled">
        <div className="payment-result__icon">❌</div>
        <h1>Payment Cancelled</h1>
        <p className="payment-result__message">
          Your payment was cancelled. No charges were made.
        </p>
        
        <p className="payment-result__note">
          Changed your mind? You can always come back and purchase credits when you're ready.
        </p>

        <div className="payment-result__actions">
          <Link to="/pricing" className="btn-primary">View Pricing</Link>
          <Link to="/dashboard" className="btn-secondary">Go to Dashboard</Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
